export function truncateDecimals(num: number, decimalPlaces: number): number {
    const factor = 10 ** decimalPlaces;
    return Math.trunc(num * factor) / factor;
}

export function roundToNearest(num: number, nearest: number = 1): number {
    return Math.round(num / nearest) * nearest;
}